var map = {
	"./22-0_thumb.jpg": 81,
	"./23-0_thumb.jpg": 82,
	"./24-0_thumb.jpg": 83,
	"./25-0_thumb.jpg": 84,
	"./26-0_thumb.jpg": 85,
	"./27-0_thumb.jpg": 86,
	"./28-0_thumb.jpg": 87,
	"./29-0_thumb.jpg": 88,
	"./3-1_thumb.jpg": 89,
	"./30-0_thumb.jpg": 90,
	"./31-0_thumb.jpg": 91,
	"./32-0_thumb.jpg": 92,
	"./33-0_thumb.jpg": 93,
	"./34-0_thumb.jpg": 94,
	"./35-0_thumb.jpg": 95,
	"./36-0_thumb.jpg": 96,
	"./37-0_thumb.jpg": 97,
	"./6-0_thumb.jpg": 98,
	"./8-0_thumb.jpg": 99,
	"./9-0_thumb.jpg": 100,
	"./loved.svg": 101
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80;